import { dueLabel, GROUP_LABEL } from '../lib/format';

export function StatusPill({ status }: { status: string }) {
  return <span className={`pill ${status}`}>{GROUP_LABEL[status] ?? status}</span>;
}

export function Chip({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  return <span className={`chip ${className}`}>{children}</span>;
}

export function KindChip({ kind }: { kind: string }) {
  return <Chip className={`kind-${kind}`}>{kind}</Chip>;
}

export function DueChip({ due }: { due: string | null | undefined }) {
  const d = dueLabel(due);
  return d ? <Chip className={`due ${d.tone}`}>{d.text}</Chip> : null;
}

export function PriorityChip({ priority }: { priority: string | null }) {
  return priority ? <Chip className={priority}>{priority}</Chip> : <Chip className="untriaged">untriaged</Chip>;
}
